/**
 * Route for `self-serve-credit-card-subscribe`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { SelfServeCreditCardSubscribePage } from "../features/self-serve-credit-card-subscribe/SelfServeCreditCardSubscribePage";

export const selfServeCreditCardSubscribeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/self-serve-credit-card-subscribe",
	component: SelfServeCreditCardSubscribePage,
});

export default selfServeCreditCardSubscribeRoute;
